






















import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";
// import VueTouch from "vue-touch";
// Vue.use(VueTouch);
@Component({})
export default class ToggleSwitch extends HacoBase {
  @Prop({ type: Number, required: false }) private enabled!: number;
  @Prop({ type: Number, required: false }) private scenarioId!: number;
  label = "Active";
  protected isEnabled = 0;
  mounted(): void {
    this.isEnabled = this.enabled;
    this.label = this.isEnabled === 1 ? "Active" : "Not Active";
  }
  protected onToggled(): void {
    if (this.isEnabled === 1) {
      this.isEnabled = 0;
      this.label = "Not Active";
    } else {
      this.isEnabled = 1;
      this.label = "Active";
    }

    this.activeNonActiveData();
  }
  activeNonActiveData(): void {
    const active: number = this.isEnabled;
    const url =
      this.$debugServer +
      "/api/v1_inner/scenario/set_active/" +
      this.scenarioId +
      "/" +
      active;
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        //
        return response;
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }
}
